<template>
  <b-dialog :name="'new-community-form'" @closed="clearData">
    <form class="uk-form-horizontal b-form" autocomplete="off" @submit.prevent="">
      <div v-if="errorMessage" class="uk-alert-danger uk-animation-slide-bottom-small" uk-alert>
        <p>{{ errorMessage }}</p>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left" for="community-name"
          >Название <span class="req-star">*</span></label
        >
        <div class="form-column--right">
          <b-input
            v-model.trim="formData.name"
            id="community-name"
            key="name"
            type="search"
            :class="{'uk-form-danger uk-animation-shake': $v.formData.name.$error}"
          />
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left" for="community-description">Описание </label>
        <div class="form-column--right">
          <b-input
            v-model.trim="formData.description"
            id="community-description"
            key="description"
            type="search"
            maxlength="200"
            :class="{'uk-form-danger uk-animation-shake': $v.formData.description.$error}"
          />
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left" for="community-unp"
          >УНП <span class="req-star">*</span></label
        >
        <div class="form-column--right">
          <b-input
            v-model.number="formData.unp"
            id="community-unp"
            key="unp"
            maxlength="9"
            :class="{'uk-form-danger uk-animation-shake': $v.formData.unp.$error}"
          />
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left">Улица <span class="req-star">*</span></label>
        <div class="form-column--right">
          <v-select
            v-model="street"
            :options="options"
            :value="street"
            :class="{'select-error uk-animation-shake': $v.street.label.$error}"
            @search:blur="clearHouse"
            @input="updateHouses"
          ></v-select>
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left">Дом <span class="req-star">*</span></label>
        <div class="form-column--right">
          <v-select
            v-model="building"
            id="building"
            :options="buildings"
            :value="building"
            :disabled="buildingDisabled"
            :class="{
              'select-error uk-animation-shake': $v.building.$error && !buildingDisabled
            }"
            @input="updateApartments"
          ></v-select>
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left">№ помещения <span class="req-star">*</span></label>
        <div class="form-column--right">
          <v-select
            v-model="apartment"
            id="apartment"
            :options="apartments"
            :disabled="apartmentDisabled"
            :class="{
              'select-error uk-animation-shake': $v.apartment.$error && !apartmentDisabled
            }"
            @input="checkApartments"
          ></v-select>
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left">Председатель <span class="req-star">*</span></label>
        <div class="form-column--right">
          <v-select
            v-model="chairman"
            :options="chairmanList"
            :class="{'select-error uk-animation-shake': $v.chairman.label.$error}"
          ></v-select>
        </div>
      </div>
    </form>
    <div class="uk-flex uk-flex-center uk-margin-medium-top">
      <b-button name="Сохранить" color="red" class="margin-right_60" @click="save" />
      <b-button name="Отменить" @click="$modal.hide('new-community-form')" />
    </div>
  </b-dialog>
</template>

<script>
import {maxLength, minLength, required, numeric} from 'vuelidate/lib/validators'
import {showSuccess} from '@/common/utils/notification'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import {mapActions} from 'vuex'

export default {
  name: 'CreateNewCommunityForm',
  props: {
    communityData: {
      type: Object,
      default: () => {}
    },
    addressData: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {vSelect},
  data() {
    return {
      errorMessage: '',
      options: [],
      chairmanList: [],
      formData: {
        name: '',
        description: '',
        unp: ''
      },
      chairman: {
        label: '',
        code: ''
      },
      street: {
        label: '',
        code: ''
      },
      building: null,
      buildings: [],
      buildingDisabled: true,
      apartment: null,
      apartments: [],
      apartmentDisabled: true
    }
  },
  methods: {
    ...mapActions({
      getStreets: 'address/GET_STREETS',
      getChairmanList: 'chairman/GET_CHAIRMAN_LIST',
      saveCommunity: 'community/SAVE_COMMUNITY',
      getStreetBuildings: 'address/GET_STREET_BUILDINGS',
      getBuildingApartments: 'address/GET_BUILDING_APARTMENTS'
    }),
    loadStreets(evaId) {
      this.getStreets()
        .then(resp => {
          let tmp = resp.map(it => {
            return {
              label: it.type + ' ' + it.name,
              code: it.id
            }
          })
          this.options = tmp
          if (evaId) {
            this.street = {
              label: this.options.find(val => val.code === evaId).label,
              code: evaId
            }
            this.updateHouses(this.street, true)
          }
        })
        .catch(err => console.log(err))
    },
    loadChairman(chairmanId) {
      this.getChairmanList()
        .then(resp => {
          let tmp = resp.content.map(it => {
            return {
              label: it.fullName,
              code: it.id
            }
          })
          this.chairmanList = tmp
          if (chairmanId) {
            let getChairman = this.chairmanList.find(el => el.code === chairmanId)
            this.chairman = {
              label: getChairman.label,
              code: getChairman.code
            }
          }
        })
        .catch(err => console.log(err))
    },
    save() {
      this.$v.$touch()
      if (!this.$v.$error) {
        let community = {
          name: this.formData.name,
          description: this.formData.description,
          unp: this.formData.unp,
          addressId: this.apartment ? this.apartment.code : +this.apartments[0].code,
          chairmanId: this.chairman.code
        }

        if (this.isEdit) {
          community = {
            ...community,
            id: this.formData.id
          }
        }

        this.saveCommunity(community)
          .then(() => {
            this.$emit('save')
            this.$modal.hide('new-community-form')
            if (this.isEdit) {
              showSuccess('Изменения успешно сохранены')
            } else {
              showSuccess('Товарищество успешно добавлено')
            }
          })
          .catch(() => {
            this.errorMessage = 'Неизвестная ошибка. Обратитесь к администратору'
            //this.errorMessage = {err}.err.response.data
          })
      } else {
        this.errorMessage = 'Правильно заполните поля!'
      }
    },
    clearHouse() {
      this.building = null
      this.apartment = null
    },
    updateHouses(val, isUpdate) {
      if (val) {
        this.getStreetBuildings(this.street.code)
          .then(resp => {
            let tmp = resp.map(it => {
              return {
                label: it,
                code: it
              }
            })
            this.buildings = tmp
            if (isUpdate)
              this.updateApartments(
                true,
                this.addressData.roomNumber,
                this.addressData.addressNumber
              )
          })
          .catch(() => (this.address = this.addressId))
        this.buildingDisabled = false
      } else {
        this.building = null
        this.buildings = []
        this.buildingDisabled = true
        this.apartment = null
        this.apartments = []
        this.apartmentDisabled = true
      }
    },
    updateApartments(val, roomNumber, roomCode) {
      if (val) {
        let address = {
          streetId: this.street.code,
          building: this.building.code
        }
        this.getBuildingApartments(address)
          .then(resp => {
            this.apartments = resp.map(it => {
              return {
                label: it.apartment,
                code: it.addressId
              }
            })
            this.checkApartments()
            if (roomNumber) {
              this.apartment = {
                label: roomNumber,
                code: roomCode
              }
            }
          })
          .catch(() => (this.address = this.addressId))
      }
    },
    loadCurrentCommunity() {
      this.formData = {
        id: this.communityData.id,
        name: this.communityData.name,
        description: this.communityData.description,
        unp: this.communityData.unp
      }
      this.loadChairman(this.communityData.chairmanId)
    },
    loadCurrentAddress() {
      this.loadStreets(+this.addressData.evaId)
      this.building = {
        label: this.addressData.building,
        code: +this.addressData.building
      }
    },
    checkApartments() {
      if (this.apartments.length < 2) {
        this.apartmentDisabled = true
        this.apartment = null
      } else {
        this.apartmentDisabled = false
      }
    },
    clearData() {
      this.errorMessage = ''
      this.formData = {
        name: '',
        description: '',
        unp: ''
      }
      this.street = {label: '', code: ''}
      this.chairman = {label: '', code: ''}
      this.building = null
      this.apartment = null
      this.buildings = []
      this.buildingDisabled = true
      this.apartments = []
      this.apartmentDisabled = true
      this.$v.$reset()

      if (this.isEdit) {
        this.loadCurrentCommunity()
        this.loadCurrentAddress()
      }
    }
  },
  validations: {
    formData: {
      name: {
        required,
        maxLength: maxLength(100)
      },
      description: {
        maxLength: maxLength(200)
      },
      unp: {
        required,
        numeric: numeric,
        maxLength: maxLength(9),
        minLength: minLength(9)
      }
    },
    street: {
      label: {
        required
      }
    },
    building: {
      required
    },
    chairman: {
      label: {
        required
      }
    },
    apartment: {
      required
    }
  },
  mounted() {
    this.loadStreets()
    this.loadChairman()
  },
  watch: {
    communityData: {
      deep: true,
      handler(val) {
        if (val && this.isEdit) {
          this.loadCurrentCommunity()
        }
      }
    },
    addressData: {
      deep: true,
      handler(val) {
        if (val && this.isEdit) {
          this.loadCurrentAddress()
        }
      }
    }
  }
}
</script>
